export default {
  xxxs: 0, //mobile
  xxs: 321,
  xs: 576,
  sm: 768, //portrait tablet
  md: 1023, //tablet
  lg: 1200, //landscape tablet / desktop
  xl: 1440, // large desktop
  xxl: 1920,
  xxxl: 2560
}

